export type VolumePage = {
  /** Image URL of the page (portrait 9:16, 1152×2048). */
  src: string
  caption: string
  alt: string
}

/** Real pages from Volume 1, Set Up the Squad, in display order. */
export const volumePages: VolumePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/pAVmhQRT8nCqSMKT2y4UtJ/carrusel-01_queue-vs-no-queue_p06.jpg',
    caption: 'The No-Queue system: three stations, everyone moving',
    alt: 'Queue Cricket vs No-Queue Cricket comparison page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/i3iJRnf6PuvZTnoFNnLn2R/carrusel-02_session-clock_p04.jpg',
    caption: 'The Session Clock: every session timed for 60, 75 or 90 minutes',
    alt: 'Session Clock page with 60, 75 and 90-minute plans',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iSemaJaUaEVoxrKjG4NQWw/carrusel-03_session-04-plan_p16.jpg',
    caption: 'Plan page: stations, distances and timings on one sheet',
    alt: 'Session 04 Plan page with bowling progression and stations',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/57GNW3kqyYJRti6DAuNcxT/carrusel-04_straight-hit-gates_p24.jpg',
    caption: 'Run It page: the game, the coaching cues and the scoring',
    alt: 'Straight-Hit Gates Run It page with match diagram and coaching cues',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dJRZHMRTVjmHUpp2TPf27k/carrusel-05_leave-or-play_p35.jpg',
    caption: 'Match games with simple points that keep every player involved',
    alt: 'Leave or Play game page with points scoring',
  },
]
